import { clsx } from 'clsx';

import styles from './Loader.module.scss';

interface LoaderProps {
  size?: number;
  stroke?: number;
  className?: string;
  white?: boolean;
}

const Loader = ({ size = 25, stroke = 3, className = '', white }: LoaderProps) => (
  <div
    className={clsx(styles.loader, styles[`loaderStroke${stroke}`], className, white && styles.white)}
    style={{ width: `${size}px`, height: `${size}px` }}
  >
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
    <div style={{ width: `${size}px`, height: `${size}px` }} />
  </div>
);

export default Loader;
